import React, { useState } from 'react';
import { WMSTileLayer } from 'react-leaflet';
import { Layers, Settings2, ChevronDown } from 'lucide-react';

export const WmsLayers = ({ activeLayers }) => activeLayers.map((layer) => (
  <WMSTileLayer
    key={layer.id}
    url={layer.url}
    layers={layer.layers}
    format={layer.format || 'image/png'}
    transparent={layer.transparent !== false}
    version={layer.version || '1.1.1'}
    opacity={layer.opacity}
    attribution={layer.attribution || 'LVM GEO'}
    zIndex={5}
  />
));

export const LayerControlPanel = ({ mapLayers, canManage, onManage, className = '' }) => {
  const [open, setOpen] = useState(false);
  const { layers, isActive, opacityOf, toggle, setOpacity } = mapLayers;
  const activeCount = layers.filter(isActive).length;

  return (
    <div className={`absolute top-3 right-3 z-[1000] ${className}`} data-testid="map-layer-panel">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-lg bg-white/95 backdrop-blur px-3 py-2 text-sm font-medium text-[#1F3D2B] shadow-md border border-[#1F3D2B]/10 hover:bg-white"
        data-testid="map-layer-toggle"
      >
        <Layers className="w-4 h-4" /> Slāņi {activeCount > 0 && <span className="rounded-full bg-[#1F3D2B] text-white text-[11px] px-1.5 py-0.5">{activeCount}</span>}
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="mt-2 w-72 max-w-[85vw] rounded-xl bg-white/95 backdrop-blur shadow-xl border border-[#1F3D2B]/10 p-3 space-y-2 animate-fade-in" data-testid="map-layer-list">
          <p className="text-xs font-semibold uppercase tracking-wide text-[#2E2E2E]/50">LVM GEO / WMS slāņi</p>
          {layers.length === 0 ? (
            <p className="text-xs text-[#2E2E2E]/60" data-testid="map-layer-empty">Nav konfigurētu slāņu.{canManage ? ' Pievienojiet tos iestatījumos.' : ''}</p>
          ) : layers.map((layer) => (
            <div key={layer.id} className="space-y-1" data-testid={`map-layer-item-${layer.id}`}>
              <label className="flex items-center gap-2 text-sm cursor-pointer">
                <input type="checkbox" checked={isActive(layer)} onChange={() => toggle(layer)} className="accent-[#1F3D2B]" data-testid={`map-layer-check-${layer.id}`} />
                <span className="flex-1 truncate" title={layer.layers}>{layer.title}</span>
              </label>
              {isActive(layer) && (
                <input
                  type="range" min="0.1" max="1" step="0.1" value={opacityOf(layer)}
                  onChange={(e) => setOpacity(layer, Number(e.target.value))}
                  className="w-full accent-[#1F3D2B]" data-testid={`map-layer-opacity-${layer.id}`}
                />
              )}
            </div>
          ))}
          {canManage && (
            <button type="button" onClick={onManage} className="w-full mt-1 flex items-center justify-center gap-1.5 rounded-lg border border-[#1F3D2B]/20 px-2 py-1.5 text-xs font-medium text-[#1F3D2B] hover:bg-[#1F3D2B]/5" data-testid="map-layer-manage">
              <Settings2 className="w-3.5 h-3.5" /> Pārvaldīt slāņus
            </button>
          )}
        </div>
      )}
    </div>
  );
};
